window.sq = window.sq || {};

(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;

    if (url && url.toLowerCase() === "https://3d7neyqe2zg4l9agv8shmcar-fast.searchtap.net/v2".toLowerCase()) {
      const body = JSON.parse(data);
      data = JSON.stringify(body);
    }
    send.call(this, data);
  }
})(XMLHttpRequest);

window.sq.onData = async data => {

  // if the language is already german, ignore it
  if (Shopify.locale === "en")
    return data;

  const fetchData = data.results.map(r => {
    return fetch("/" + Shopify.locale + "/products/" + r.handle + ".json") 
      .then(res => res.json())
      .then(d => r.title = d.product.title)
      //.catch(e => r.title)
  })
  await Promise.all(fetchData);
  
  return data;
}


window.sq.onComplete = (el,opts)=>{

  window.sq.params();
  window.sq.setupMobileSort(el);
  window.sq.filterConditions(el, opts);

  if(Shopify.locale === "ar"){
    window.sq.translateCollection(el);
    window.sq.translateCategory(el);
    window.sq.translateBrand(el);
    window.sq.translateGender(el);
    window.sq.translateActivity(el);
    window.sq.translateSize(el);
    window.sq.translateAvailability(el);
    window.sq.translateFilterTitle(el);
    window.sq.translatePriceFilter(el);
    window.sq.translateFilterBy(el);
    window.sq.translateClear(el);
  }
}

window.sq.setupMobileSort = (el) => {
  const tpl = `
    <div class="sq-sticky-bar">
      <div class="sq-sort"> 
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <div class="sq-image">
          <img src = "data:image/png;base64,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"></img>
        </svg>
        </div>
        &nbsp;
        <select class="sparq-selectbox-mobile"> 
          <option value="-1">Sort</option> 
          <option value="2">Price: Low To High</option> 
          <option value="3">Price: High To Low</option> 
          <option value="4">Alphabetically: A-Z</option> 
          <option value="5">Alphabetically: Z-A</option> 
          <option value="6">Date, New to Old</option> 
          <option value="7">Date, Old to New</option> 
        </select>
      </div>
      <div class="sq-filter-btn">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <div class="sq-image">
        <img src = "data:image/png;base64,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"></img>
        </svg>
      </div>
        Filters
      </div>
    </div>
    `;

  const contEl = el.querySelector(".desktop-wrapper .filter-mobile-button");
  let stickEl = el.querySelector(".sq-sticky-bar");

  // if the element is already added, do not add again
  if (stickEl) return;

  if (!contEl) return;

  contEl.insertAdjacentHTML("afterend", tpl);
  const sortEl = el.querySelector(".sq-sort");
  const filterBtn = el.querySelector(".sq-filter-btn");

  sortEl.addEventListener("change", (evt) => {
    const url = new URL(location.href);
    url.searchParams.set("sortValue", evt.target.value);
    location.assign(url.search);
    evt.target.value = "-1";
  });

  filterBtn.addEventListener("click", window.sq.toggleSidebar);
};



window.sq.toggleSidebar = function () {
  const body = document.querySelector("body");
  const cssClass = "sq-open-filter";
  const sidebar = document.querySelector(".sq-filter-sidebar");
  const overlay = document.querySelector(".sq-overlay");
  if (!sidebar) return;

  body.classList.toggle(cssClass);
  sidebar.classList.toggle(cssClass);
  overlay.classList.toggle(cssClass);
};


window.sq.filterConditions = (el, opts) => {
  // do not run for dropdown
  if (opts.UIType === "dropdown") return;

  // setup initial elements
  const sidebar = el.querySelector(".sq-filter-sidebar");
  const filterWrapper = el.querySelector(".sq-filters-wrapper");

  let overlay = el.querySelector(".sq-overlay");
  let btnApply = el.querySelector(".sq-btn-apply");
  let filterCrossBtn = el.querySelector(".sq-close");

  // let btnFilter = document.querySelector("#sq-btn-filter");
  let sqContainer = el.querySelector(".sparq-container-fluid");

  // add overlay only if its not added already
  if (sidebar && !overlay) {
    // insert the overlay class
    sidebar.insertAdjacentHTML("afterend", "<div class='sq-overlay'></div>");
  }

  if (sidebar && !filterCrossBtn) {
    // add the close button in the sidebar
    sidebar.insertAdjacentHTML("afterbegin", "<div class='sq-close'></div>");
  }

  // add the btn filter
  if (filterWrapper && !btnApply) {
    // insert the btn HTML
    filterWrapper.insertAdjacentHTML(
      "afterend",
      "<div class='sq-btn-apply'>Apply</div>"
    );
  }

  // // move the button only if not inside the sq container
  // if (!sqContainer.querySelector("#sq-btn-filter")) {
  //   let elInfo = el.querySelector(".sq-sort");
  //   elInfo.prepend(btnFilter);
  // }

  // setup close events for all required elements
  overlay = el.querySelector(".sq-overlay");
  btnApply = el.querySelector(".sq-btn-apply");
  filterCrossBtn = el.querySelector(".sq-close");

  if (overlay) {
    overlay.removeEventListener("click", window.sq.toggleSidebar);
    overlay.addEventListener("click", window.sq.toggleSidebar);
  }

  if (btnApply) {
    btnApply.removeEventListener("click", window.sq.toggleSidebar);
    btnApply.addEventListener("click", window.sq.toggleSidebar);
  }

  if (filterCrossBtn) {
    filterCrossBtn.removeEventListener("click", window.sq.toggleSidebar);
    filterCrossBtn.addEventListener("click", window.sq.toggleSidebar);
  }
};


window.sq.params = () =>{
  if (Shopify.locale === "ar") {
  let container = document.querySelector(".sparq-container-fluid");
  let count = document.querySelectorAll("span.float-right.sq-filter-value-count");
    container.classList.add("lang");
    count.forEach((e) => e.style.width = "100%")
  }
  else{
    return;
  }
}

window.sq.translateCollection = (el) =>{
  const translateLabels = document.querySelectorAll(".sparq-sidebar.box-shadow.sparq-list-box-tags_collection_jzd87d39usha8bvuigdoys8l .sparq-checkbox");
  
  translateLabels.forEach((e) =>{
    const arText = e.querySelector(".capitalize").innerText;
    e.querySelector(".capitalize").innerText = window.sq.d.collection[arText] || arText;
  });
}

window.sq.translateCategory = (el) =>{
  const translateLabels = document.querySelectorAll(".sparq-sidebar.box-shadow.sparq-list-box-tags_category_9gc7z8z9efolr85wmxjwcfph .sparq-checkbox");
  
  translateLabels.forEach((e) =>{
    const arText = e.querySelector(".capitalize").innerText;
    e.querySelector(".capitalize").innerText = window.sq.d.category[arText] || arText;
  });
}

window.sq.translateBrand = (el) => {
  const translateLabels = document.querySelectorAll(".sparq-sidebar.box-shadow.sparq-list-box-system_vendor .sparq-checkbox");
  
  translateLabels.forEach((e) =>{
    const arText = e.querySelector(".capitalize").innerText;
    e.querySelector(".capitalize").innerText = window.sq.d.brand[arText] || arText;
  });
}

window.sq.translateGender = (el) => {
  const translateLabels = document.querySelectorAll(".sparq-sidebar.box-shadow.sparq-list-box-tags_gender_cqnudlukdscleokh3kibs4at .sparq-checkbox");
  
  translateLabels.forEach((e) =>{
    const arText = e.querySelector(".capitalize").innerText;
    e.querySelector(".capitalize").innerText = window.sq.d.gender[arText] || arText;
  });
}

window.sq.translateActivity = (el) => {
  const translateLabels = document.querySelectorAll(".sparq-sidebar.box-shadow.sparq-list-box-tags_type_of_activity_cry49kxr6vx8n33nckzpolk4 .sparq-checkbox");
  
  translateLabels.forEach((e) =>{
    const arText = e.querySelector(".capitalize").innerText;
    e.querySelector(".capitalize").innerText = window.sq.d.activity[arText] || arText;
  });
}

window.sq.translateSize = (el) => {
  const translateLabels = document.querySelectorAll(".sparq-sidebar.box-shadow.sparq-list-box-option_size_d374mb2azy39jqslz5guo4is .sparq-checkbox");
  
  translateLabels.forEach((e) =>{
    const arText = e.querySelector(".capitalize").innerText;
    e.querySelector(".capitalize").innerText = window.sq.d.size[arText] || arText;
  });
}

window.sq.translateAvailability = (el) => {
  const translateLabels = document.querySelectorAll(".sparq-sidebar.box-shadow.sparq-list-box-system_availability .sparq-checkbox");
  
  translateLabels.forEach((e) =>{
    const arText = e.querySelector(".capitalize").innerText;
    e.querySelector(".capitalize").innerText = window.sq.d.availability[arText] || arText;
  });
}

window.sq.translateFilterTitle = (el) => {
  const translateLabels = document.querySelectorAll(".title");
  translateLabels.forEach((e) =>{
    const arText = e.innerText;
    e.innerText = window.sq.d.filterTitle[arText] || arText;
  });
}

window.sq.translatePriceFilter = (el) => {
  const translateLabels = document.querySelector("#sparq-container > div > div > div.sparq-search-outer.over-search-field > div > div > div.column.column-25.hidden-xs.hidden-sm.sq-filter-sidebar.sq-sidebar-md > div > div.sq-filters-wrapper > div.sparq-sidebar.box-shadow.sparq-list-box-price_price_filter > div > div > div.sparq-title-container > h5")
    const arText = translateLabels.innerText;
    translateLabels.innerText = window.sq.d.priceFilter[arText] || arText;
}

window.sq.translateFilterBy = (el) => {
  const translateLabels = document.querySelector("#sparq-container > div > div > div.sparq-search-outer.over-search-field > div > div > div.column.column-25.hidden-xs.hidden-sm.sq-filter-sidebar.sq-sidebar-md > div > div.sparq-search-title > h5")
    const arText = translateLabels.innerText;
    translateLabels.innerText = window.sq.d.filterBy[arText] || arText;
}

window.sq.translateClear = (el) =>{
  const translateLabels = document.querySelector("#sparq-container > div > div > div.sparq-search-outer.over-search-field > div > div > div.column.column-25.hidden-xs.hidden-sm.sq-filter-sidebar.sq-sidebar-md > div > div.sparq-search-title > div > span")
  const arText = translateLabels.innerText;
  translateLabels.innerText = window.sq.d.clear[arText] || arText;
}

window.sq.d = {
  collection : [],
  category : [],
  brand : [],
  gender: [],
  activity: [],
  size: [],
  availability: [],
  filterTitle: [],
  priceFilter: [],
  filterBy: [],
  clear: [],
};

//collection translation

window.sq.d.collection["Accessories"] = "ملحقات";
window.sq.d.collection["Bags"] = "أكياس";
window.sq.d.collection["Caps"] = "قبعات";
window.sq.d.collection["Hijab"] = "الحجاب";

//category translation

window.sq.d.category["Pants"] = "بنطال";
window.sq.d.category["Socks"] = "جوارب";
window.sq.d.category["Set"] = "تعيين";
window.sq.d.category["Gloves"] = "القفازات";

//brand translation

window.sq.d.brand["Nike"] = "نايك";
window.sq.d.brand["Adidas"] = "شركة اديداس";
window.sq.d.brand["Puma"] = "بوما";
window.sq.d.brand["Reebok"] = "ريبوك";
window.sq.d.brand["Under Armour"] = "تحت الدرع";
window.sq.d.brand["Adidas Originals"] = "اديداس اوريجينالز";
window.sq.d.brand["Squatwolf"] = "سكوات وولف";
window.sq.d.brand["Hummel"] = "هاميل";

//gender translation

window.sq.d.gender["Kids"] = "أطفال";
window.sq.d.gender["Unisex"] = "للجنسين";
window.sq.d.gender["Kids/Boys"] = "أطفال / بنين";
window.sq.d.gender["Kids/Unisex"] = "أطفال / للجنسين";
window.sq.d.gender["Kids/Girls"] = "أطفال / بنات";

//activity translation

window.sq.d.activity["Life Style"] = "أسلوب الحياة";
window.sq.d.activity["Training"] = "تمرين";

//size translation

window.sq.d.size["1 Year"] = "السنة الأولى";
window.sq.d.size["2 Years"] = "سنوات 2";
window.sq.d.size["2.5 Years"] = "سنوات 2.5";
window.sq.d.size["2xl"] = "2xl";
window.sq.d.size["2xs"] = "2xs";
window.sq.d.size["3 Months"] = "الأشهر 3";
window.sq.d.size["3 Years"] = "سنوات 3";
window.sq.d.size["3xl"] = "3xl";

//availability transaltion

window.sq.d.availability["Include Out Of Stock"] = "تضمين نفاد المخزون";

//filter title translation

window.sq.d.filterTitle["COLLECTION"] = "مجموعة";
window.sq.d.filterTitle["CATEGORY"] = "الفئة";
window.sq.d.filterTitle["BRAND"] = "ماركة";
window.sq.d.filterTitle["GENDER"] = "جنس";
window.sq.d.filterTitle["TYPE OF ACTIVITY"] = "نوع النشاط";
window.sq.d.filterTitle["SIZE"] = "بحجم";
window.sq.d.filterTitle["AVAILABILITY"] = "التوفر";

//price filter translation
window.sq.d.priceFilter['PRICE FILTER'] = "مرشح السعر"

//filter by translation
window.sq.d.filterBy['FILTER BY'] = "مصنف بواسطة" 

//clear translation
window.sq.d.clear["CLEAR"] = "صافي"
